import { ClubType } from '@fable/types'
import { useClubBookPromo } from 'app/clubs/hooks'
import { getClubType } from 'app/clubs/utils'
import { useActions } from 'hooks'
import {
  ClubBookPromoModal,
  ClubJoinedModal,
} from 'app/clubs/components/club_detail/modals'
import { analytics } from 'segment_analytics'
import { modalHeightAuto } from 'utils'

const useShowQrModal = (state: any) => {
  const ctx = state.context
  const club = ctx.club
  const { openModal } = useActions()
  const promoTest = useClubBookPromo({ ctx })

  const showQrCodeModal = () => {
    if (!club) return
    const clubType = getClubType({ club, checkParam: true })

    let content = (
      <ClubJoinedModal club={club} clubType={clubType as ClubType} />
    )

    if (promoTest.active) {
      analytics.events.ebookPromoUpsell.seen()
      content = <ClubBookPromoModal club={club} clubType={clubType} />
    }

    openModal(content, modalHeightAuto)
  }

  return { showQrCodeModal, promoTest }
}

export default useShowQrModal
